import { useEffect, useState } from 'react';

/** Seconds since `active` turned on, ticking each second; 0 while off. */
export const useElapsedSeconds = (active: boolean): number => {
  const [elapsed, setElapsed] = useState(0);
  useEffect(() => {
    if (!active) {
      setElapsed(0);
      return undefined;
    }
    const timer = window.setInterval(
      () => setElapsed((value) => value + 1),
      1000,
    );
    return () => window.clearInterval(timer);
  }, [active]);
  return elapsed;
};

/** The wall clock, ticking each second while something is running. */
export const useNowWhile = (active: boolean): number => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!active) return undefined;
    setNow(Date.now());
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [active]);
  return now;
};

export const useSecondsSince = (
  startedAt: number | string | null | undefined,
  active: boolean,
): number | null => {
  const now = useNowWhile(active);
  const startedMs =
    typeof startedAt === 'string'
      ? new Date(startedAt).getTime()
      : startedAt ?? NaN;
  return Number.isFinite(startedMs)
    ? Math.max(0, Math.floor((now - startedMs) / 1000))
    : null;
};
